import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../components/Header.js";
import api from "../containers/api";
import icon from "../images/icone-guarde-seu-documento.png";
import moment from "moment";
import toast from "react-simple-toasts";
export class AccessAllDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cpf: "",
      stringBase64: null,
      loading: false,
      idDocSel: null,
      documents: [],
      nameDoc: "",
    };
  }

  _handleKeyUp = (e) => {
    if (e.key === "Enter" && this.state.cpf.replace(/[^a-z0-9]/gi, "").length === 11) {
      this.handleClick();
    }
  };

  componentDidMount() {
    if (this.props.keyCallback) {
      api
        .get(`/checkAuthStatus/${this.props.keyCallback}`)
        .then((res) => {
          if (res.data.code === 1) {
            api
              .get(`/signedDocumentListAll/${this.props.keyCallback}`)
              .then((response) => {
                this.setState({ documents: response.data.documents });
              })
              .catch((error) => {
                this.onError(error);
              });
          } else {
            let url = window.location.origin;
            window.location.replace(url);
          }
        })
        .catch((error) => {
          this.onError(error);
        });
    }
  }

  handleClick(e) {
    api
      .post(`/checkSignedDocuments/`, { cpf: this.state.cpf })
      .then((res) => {
        api
          .post(`/auth/generateUrl/`, { cpf: this.state.cpf })
          .then((response) => {
            window.location = response.data.signUrl + `&urlCallback=${window.location.origin}/allDocuments`;
          })
          .catch((error) => {
            this.onError(error);
          });
      })
      .catch((error) => {
        this.onError(error);
      });
  }

  _onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClickDownload = async (id, index) => {
    this.setState({ loading: true });
    api
      .get(`/signedDocumentAuth/${this.props.keyCallback}?docId=${id}`)
      .then((response) => {
        this.setState({
          stringBase64: response.data.document,
          loading: false,
          idDocSel: index,
          nameDoc: response.data.name,
        });
        document.getElementById("download").click();
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.onError(error);
      });
  };

  onError(error) {
    if (error && error.response && error.response.data && error.response.data.message) {
      toast(error.response.data.message);
    } else {
      toast("Ocorreu um erro interno na aplicação!");
    }
  }

  render() {
    return (
      <div className="container h-100">
        <Header logo={this.props.logo} />
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5 ">
            {this.props.keyCallback ? (
              <>
                <img src={icon} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block" />
                <h1 className="card-title fw-bold text-white mt-3">GUARDE SEUS DOCUMENTOS</h1>
                {!this.state.loading ? (
                  <ul style={{ listStyleType: "none" }}>
                    {this.state.documents.map((value, index) => {
                      return (
                        <li key={index}>
                          <div style={{ border: "1px solid" }} className="container mt-2">
                            <h5 className="card-text text-light mt-2 mb-4">Data da Assinatura {moment(value.registrationDate).format("DD/MM/YYYY")} </h5>
                            {value.docIds.map((item, index) => {
                              return (
                                <div className="row">
                                  <div className="col">
                                    <h5 className="card-text text-light mb-2">
                                      SALVAR DOCUMENTO &nbsp;&nbsp;{index + 1} &nbsp;&nbsp;&nbsp;&nbsp;
                                      <i className="fa fa-download" onClick={() => this.handleClickDownload(item, index + 1)}></i>
                                    </h5>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div className="row justify-content-center">
                    <div className="col-12 d-grid">
                      <main className="position-relative">
                        <div className="loading-bar-container ">
                          <div className=" loading-bar-container loading-bar" />
                        </div>
                        <h5 className="position-absolute start-50 translate-middle mt-4">Aguarde...</h5>
                      </main>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <h5 className="mt-5 card-text text-light">DIGITE SEU CPF</h5>
                <div className="col-6 d-grid" style={{ margin: "auto" }}>
                  {/* <MaskedInput mask="111.111.111-11" name="cpf" size="20" className="text-dark text-center" onChange={this._onChange} onKeyUp={this._handleKeyUp} /> */}
                  <input
                    type="text"
                    name="cpf"
                    size="20"
                    maxLength="14"
                    className="text-dark text-center"
                    value={this.state.cpf}
                    onChange={(e) => {
                      // Remove tudo que não for número
                      let value = e.target.value.replace(/\D/g, "");
                      // Aplica a máscara: 111.111.111-11
                      value = value
                        .replace(/^(\d{3})(\d)/, "$1.$2")
                        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
                        .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
                      this.setState({ cpf: value, showError: false });
                    }}
                    onKeyUp={this._handleKeyUp}
                  />
                </div>
                <div className="row justify-content-center" style={{ margin: "auto" }}>
                  <div className="mt-5 col-4 d-grid">
                    <button className="mt-5 btn btn-primary fw-bold" disabled={this.state.cpf.replace(/[^a-z0-9]/gi, "").length !== 11} type="button" onClick={() => this.handleClick()}>
                      Acessar
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <a id="download" style={{ display: "none" }} className="text-white" download={`${this.state.nameDoc}.pdf`} href={`data:application/octet-stream;base64,${this.state.stringBase64}`} />
      </div>
    );
  }
}

AccessAllDocuments.propTypes = {
  keyCallback: PropTypes.string,
};

export default AccessAllDocuments;
